import React, { useState, useEffect } from 'react';
import { PdfCatalogCard } from '../components/site/PdfCatalogCard';
import { SEOHead } from '../components/site/SEOHead';
import api from '../lib/api';

export default function ECatalog() {
  const [catalogs, setCatalogs] = useState([]);
  const [seo, setSeo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/catalogs?active_only=true'),
      api.get('/seo/catalog')
    ]).then(([c, s]) => {
      setCatalogs(c.data);
      setSeo(s.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="ecatalog-page">
      <SEOHead title={seo.title} description={seo.description} keywords={seo.keywords} />
      
      {/* Hero Banner */}
      <div className="relative py-16 md:py-24 bg-[#0f1419]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            E-Katalog
          </h1>
          <p className="text-gray-300 mt-2">Projelerimizin detaylı kataloglarını indirin</p>
          <div className="mt-4 w-16 h-1 rounded-full bg-[hsl(var(--gold))]" />
        </div>
      </div>

      {/* Catalog Grid */}
      <section className="py-14 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          {loading ? (
            <div className="flex justify-center py-20">
              <div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" />
            </div>
          ) : catalogs.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-muted-foreground">Henüz katalog eklenmemiştir.</p>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-testid="catalog-grid">
              {catalogs.map(catalog => (
                <PdfCatalogCard key={catalog.id} catalog={catalog} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
